import React from 'react';
import merge from 'lodash/merge';
import Chart from '../chart';
import './css/linear_gauge.css';
var bulletOptions = _ref => {
  var {
    options,
    theme
  } = _ref;
  var yMax;
  try {
    var _options$series;
    yMax = (options === null || options === void 0 || (_options$series = options.series) === null || _options$series === void 0 || (_options$series = _options$series[0]) === null || _options$series === void 0 || (_options$series = _options$series.data) === null || _options$series === void 0 ? void 0 : _options$series[0]).target;
  } catch (error) {
    yMax = 100;
  }
  var newOptions = options;
  newOptions.chart.type = 'bullet';
  newOptions.series.unshift({
    data: [{
      y: yMax,
      // @ts-expect-error property not present?
      target: yMax,
      color: theme.colorChartStartGray
    }]
  });
  return newOptions;
};
var linearGaugeOptions = _ref2 => {
  var {
    theme
  } = _ref2;
  return {
    chart: {
      marginTop: 25,
      inverted: true,
      paddingLeft: 10,
      type: 'bullet'
    },
    exporting: {
      enabled: false
    },
    legend: {
      enabled: false
    },
    plotOptions: {
      series: {
        borderRadius: theme.borderRadius3,
        borderWidth: 0,
        color: theme.colorChartStartCategories,
        dataLabels: {
          style: {
            color: theme.palette.foreground.default,
            fontSize: theme.typography.size2,
            fontWeight: 'normal',
            lineHeight: theme.typography.lineHeight3
          },
          useHTML: true
        },
        grouping: false,
        groupPadding: 0,
        pointPadding: 0,
        targetOptions: {
          height: 0,
          width: 0
        }
      },
      bullet: {
        enableMouseTracking: false
      }
    },
    title: {
      text: null
    },
    xAxis: {
      height: 12,
      labels: {
        align: 'left',
        style: {
          color: theme.palette.foreground.light,
          fontSize: theme.typography.size2,
          lineHeight: theme.typography.lineHeight3
        },
        x: 0,
        y: -15
      },
      lineColor: theme.colorChartStartCategories,
      lineWidth: 0,
      max: 0,
      maxPadding: 0,
      min: 0,
      minPadding: 0,
      tickLength: 0,
      visible: true
    },
    yAxis: {
      gridLineWidth: 0,
      labels: {
        enabled: false
      },
      min: 0,
      minPadding: 0,
      title: null
    }
  };
};
var LinearGauge = /*#__PURE__*/React.forwardRef((_ref3, ref) => {
  var {
    options,
    theme
  } = _ref3;
  var chartOptions = React.useMemo(() => {
    var mergedOptions = merge(linearGaugeOptions({
      theme
    }), options);
    return bulletOptions({
      options: mergedOptions,
      theme
    });
  }, [options, theme]);
  return /*#__PURE__*/React.createElement(Chart, {
    options: chartOptions,
    ref: ref,
    theme: theme
  });
});
LinearGauge.displayName = 'LinearGauge';
export default LinearGauge;